import React from "react";
import PropTypes from "prop-types";

const CodePromoButton = ({ codeEnding, onClick }) => {
    return (
        <a
            className="btn btn--coupon btn--coupon-cover mb-3"
            rel="nofollow"
            onClick={onClick}
        >
            <b className="btn--coupon-text">GET MY CODE</b>
            <span className="btn--coupon-layer-container">
                <b className="btn--coupon-code">{codeEnding}</b>
                <span className="btn--coupon-layer"></span>
                <span className="btn--coupon-image"></span>
            </span>
        </a>
    );
};

CodePromoButton.defaultProps = {
    codeEnding: PropTypes.string,
    onClick: PropTypes.func.isRequired,
};

export default CodePromoButton;
